export default __webpack_public_path__ + "static/1910_1920-35ac57e7094ba5fdf86b0469b0711df2.mp4";